import React from 'react';
import Image from 'next/image';
import ExecutiveSummary from './ExecutiveSummary';
import ReportSection from './Common/ReportSection';
import NewsletterWhitepaper from '../PressRelease/WhitePaper';
import RecentArticle from './RecentArticle';
import BlogSection from './Common/BlogSection';
import InfographicSection from './Common/InfographicsSection';
import { space } from 'postcss/lib/list';

const ConferenceDetails = ({ data, year }) => {
    const contentStyles = {
        ul: {
            listStyleType: 'disc',
            paddingLeft: '20px',
            margin: '16px 0',
            listStyle: 'inside !important',
        },
        ol: {
            listStyleType: 'decimal',
            paddingLeft: '20px',
            margin: '16px 0',
        },
        li: {
            marginBottom: '8px',
            whiteSpace: 'initial',
        },
    };
    return (
        <>
            <div className='w-11/12 mx-auto my-6 xl:max-w-screen max-w-screen-2xl lg:my-12'>
                <div className='grid grid-cols-12 gap-4'>
                    <div className='col-span-12 lg:col-span-9'>
                        <h1 className='mb-4 text-xl font-semibold'>{data[0]?.heading_h1}</h1>
                        {/* {
                            data[0]?.image ? <Image width="2000" height="2000" src={process.env.IMG_CDN + data[0]?.image} alt={data[0]?.image_alt} /> : null
                        } */}
                        <div className='formatting' dangerouslySetInnerHTML={{ __html: data[0]?.content }}></div>
                        {(data[0]?.tags && data[0]?.tags.length > 0) && (
                            <div className='p-3 border'>
                                <span className="text-semibold">Tags:</span>
                                <span className='ml-2'>
                                    {
                                        data[0]?.tags?.map((item, index) => (
                                            <span key={index}>
                                                <button className='py-1 mr-2 px-2 bg-[#dee2e6] rounded hover:bg-[#1e5df3] hover:text-white'>
                                                    {item}
                                                </button>
                                            </span>
                                        ))
                                    }
                                </span>
                            </div>
                        )}
                    </div>
                    <div className='sticky top-0 col-span-12 lg:col-span-3'>
                        <ExecutiveSummary title="Executive Summary" data={data ? data : []} />
                        <div className='sticky my-4 top-20'>
                            <ReportSection ReportData={(data[0]?.report_id) ? (data[0]?.report_id) : []} />
                            <BlogSection blogs={(data[0]?.blogs) ? (data[0]?.blogs) : []} />
                            <InfographicSection infographics={(data[0]?.infographics) ? (data[0]?.infographics) : []} />
                            <NewsletterWhitepaper />
                        </div>
                    </div>
                </div>
            </div>
            <RecentArticle event={data[0]?.conference_type} slugPrefix="article" />
        </>
    )
}
export default ConferenceDetails
